import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminCustomerCategories = async (params = {}) => {
    if (!params.languageCode) params.languageCode = 'vi';
    if (!params.pageSize) params.pageSize = 1000;
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.CUSTOMER_CATEGORIES.GET_ALL, { params });
    return response.data;
};

export const getAdminCustomerCategoryById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.CUSTOMER_CATEGORIES.GET_BY_ID(id));
    return response.data;
};

export const createCustomerCategory = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.CUSTOMER_CATEGORIES.CREATE, data);
    return response.data;
};

export const updateCustomerCategory = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.CUSTOMER_CATEGORIES.UPDATE(id), data);
    return response.data;
};

export const deleteCustomerCategory = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.CUSTOMER_CATEGORIES.DELETE(id));
    return response.data;
};
